export enum ImageTypesEnum {
  IMAGE,
  ICON,
  NO_IMAGE,
}

// The values are the day keys of the working hours of the server
export enum WeekDay {
  Monday = 'mon',
  Tuesday = 'tue',
  Wednesday = 'wed',
  Thursday = 'thu',
  Friday = 'fri',
  Saturday = 'sat',
  Sunday = 'sun',
}
